export default "__VITE_ASSET__B4MRRlG2__"